import api from '../services/api';
import { IDentalTreatment, IDentalTreatmentItem } from '../shared/interfaces';

interface IResponseGetDentalTreatments {
  data: IDentalTreatment[];
  count: number;
}

export const getDentalTreatments = async (
  client_id: string | undefined,
  take: number,
  skip: number,
  keyword?: string,
  type?: number | null,
): Promise<IResponseGetDentalTreatments> => {
  const response = await api.post('/dental-treatments/list', {
    client_id,
    take,
    skip,
    keyword,
    type,
  });
  return response.data;
};

interface IResponseGetDentalTreatment {
  treatment: IDentalTreatment;
  items: IDentalTreatmentItem[];
}

interface IResponseCreateDentalTreatment {
  treatment: IDentalTreatment;
  list: IDentalTreatmentItem[];
}

export const getDentalTreatment = async (
  id: string | undefined,
): Promise<IResponseGetDentalTreatment> => {
  if (!id) {
    throw new Error('ID do tratamento não fornecido.');
  }
  const response = await api.get(`/dental-treatments/${id}`);
  return response.data;
};

export const postDentalTreatment = async (
  payload: any,
): Promise<IResponseCreateDentalTreatment> => {
  const response = await api.post('/dental-treatments', payload);
  return response.data;
};

export const patchDentalTreatment = async (
  id: string | undefined,
  payload: any,
): Promise<IDentalTreatment> => {
  if (!id) {
    throw new Error('ID do tratamento não fornecido.');
  }
  const response = await api.patch(`/dental-treatments/${id}`, payload);
  return response.data;
};
